const pythonCode = (asset) => ["python", ""].includes(String(asset?.source_language || "").toLowerCase())
  ? String(asset?.source_code || "").trim() : "";

// Keep transparency in the saved program, so reloading and Word use the same
// background without erasing white labels or other authored drawing objects.
export const withHandoutTransparentBackground = (code) => {
  const source = String(code || "").trim();
  if (!source) return source;
  const transparent = source.includes("# handout: transparent canvas") ? source : `${source}\n\n# handout: transparent canvas\nimport matplotlib.pyplot as plt\nplt.gcf().patch.set_alpha(0)\nfor _handout_axes in plt.gcf().axes:\n    _handout_axes.patch.set_alpha(0)`;
  return transparent;
};

export const getHandoutImagePythonCode = (image) => [image?.asset, image?.backgroundRemoval?.redrawAsset, image?.backgroundRemoval?.originalAsset]
  .map(pythonCode).find(Boolean) || "";

// Apply only after the current draft was explicitly rendered and accepted.
// The preview pixels stay in the bounded render cache, not in the saved record.
export const applyHandoutPythonRedraw = (image, code, dimensions = {}) => {
  const source = withHandoutTransparentBackground(code);
  if (!source) throw new Error("請先輸入 Python 圖碼。");
  const asset = { ...image.asset, source_code: source, source_language: "python", url: "", storage_key: "", mime_type: "image/png" };
  for (const field of ["key", "_preview_url", "_previewUrl", "_preview_source_code", "preview_url", "preview_status", "preview_message", "_previewStatus", "_previewMessage", "width_px", "height_px"]) delete asset[field];
  if (dimensions.width > 0 && dimensions.height > 0) {
    asset.width_px = dimensions.width; asset.height_px = dimensions.height;
  }
  return { ...image, asset, ...(image.backgroundRemoval ? {
    backgroundRemoval: { ...image.backgroundRemoval, redrawAsset: { ...asset } },
  } : {}) };
};
